<template>
  <v-dialog
    v-model="dialog"
    transition="fade-transition"
    :fullscreen="false"
    :width="fullScreen ? 'calc(100vw - 120px)' : 800"
    :disabled="disabled || isUpload"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-if="minimilize" icon v-bind="attrs" v-on="on" class="my-n2" :disabled="disabled">
        <BaseIcon :icon="'file-' + defaultFile.type" :color="'#757575'" />
      </v-btn>
      <template v-else>
        <div
          class="preview"
          :class="{
            'preview--picture': defaultFile.type === 'image' && !isFileList,
            'preview--video': defaultFile.type === 'video' && !isFileList,
            'preview--upload': isUpload,
            'preview--select': !!isSelect,
          }"
        >
          <template
            v-if="(defaultFile.type === 'image' || defaultFile.type === 'video') && !isFileList"
          >
            <v-img
              v-if="defaultFile.type === 'image'"
              class="preview-picture"
              v-bind="attrs"
              v-on="on"
              :src="defaultFile.url"
              alt=""
              :max-width="!!isSelect ? '100%' : '100px'"
              :max-height="!!isSelect ? '300px' : '100px'"
              :min-width="!!isSelect ? 'auto' : '100px'"
              :min-height="!!isSelect ? 'auto' : '100px'"
              :contain="!!isSelect"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <VideoPlayer
              v-else-if="defaultFile.type === 'video'"
              :src="defaultFile.url"
              :preview="true"
              @click="dialog = true"
              :max-height="!!isSelect ? 'auto' : '250px'"
              :min-height="!!isSelect ? 'auto' : '250px'"
            />
            <div v-if="isUpload" class="preview__loader gap-2">
              <transition name="fade" mode="out-in">
                <v-progress-circular
                  v-if="!uploadInfo || (uploadInfo && uploadInfo.percentage <= 99)"
                  :indeterminate="!uploadInfo"
                  :rotate="-90"
                  :size="30"
                  :width="3"
                  :value="uploadInfo && uploadInfo.percentage"
                  color="white"
                />
                <BaseIcon
                  v-else-if="uploadInfo && uploadInfo.percentage === 100"
                  width="30px"
                  height="30px"
                  icon="mark-check"
                  color="#ffffff"
                />
              </transition>
              <div class="f10 upload_size" v-if="uploadInfo !== undefined">
                {{
                  $formatFileSizeUploadUnits({
                    total: uploadInfo.total,
                    loaded: uploadInfo.loaded,
                  })
                }}
              </div>
            </div>
          </template>
          <div
            v-else
            class="preview-file"
            :class="{
              'preview-file--upload': isUpload,
              'preview-file--select': !!isSelect,
              'preview-file--media': isFileList,
            }"
            icon
            v-bind="attrs"
            v-on="on"
          >
            <transition v-if="isUpload" name="fade" mode="out-in">
              <v-progress-circular
                v-if="!uploadInfo || (uploadInfo && uploadInfo.percentage <= 99)"
                :indeterminate="!uploadInfo"
                :rotate="-90"
                :size="30"
                :width="2"
                :value="uploadInfo && uploadInfo.percentage"
                color="primary"
              />
              <BaseIcon
                v-else-if="uploadInfo && uploadInfo.percentage === 100"
                width="30px"
                height="30px"
                icon="mark-check"
                color="#277faf"
              />
            </transition>
            <template v-else>
              <template
                v-if="isFileList && (defaultFile.type === 'image' || defaultFile.type === 'video')"
              >
                <v-img
                  v-if="defaultFile.type === 'image'"
                  class="preview-picture"
                  v-bind="attrs"
                  v-on="on"
                  :src="defaultFile.url"
                  alt=""
                  :max-width="'75px'"
                  :max-height="'75px'"
                  :min-width="'75px'"
                  :min-height="'75px'"
                >
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
                <VideoPlayer
                  v-else-if="defaultFile.type === 'video'"
                  :src="defaultFile.url"
                  :preview="true"
                  @click="dialog = true"
                  :max-height="'75px'"
                  :min-height="'75px'"
                />
              </template>
              <BaseIcon
                v-else
                :icon="'file-' + defaultFile.type"
                :color="'#757575'"
                :width="isFileList ? '75px' : '30px'"
                :height="isFileList ? '75px' : '30px'"
              />
            </template>
            <div class="preview-file-text">
              <div class="preview-file-text-header">
                <div class="preview-file-text-header-name">
                  {{ defaultFile.name }}
                </div>
                <div class="preview-file-text-extension">
                  {{ '.' + defaultFile.format }}
                </div>
              </div>
              <div class="preview-file-size" v-if="defaultFile.size">
                {{
                  !isUpload
                    ? defaultFile.size
                    : (uploadInfo !== undefined &&
                        $formatFileSizeUploadUnits({
                          total: uploadInfo.total,
                          loaded: uploadInfo.loaded,
                        })) ||
                      defaultFile.size
                }}
              </div>
            </div>
          </div>
          <div class="preview-buttons" v-if="isSelect && !isUpload">
            <button
              v-if="typeof isSelect === 'boolean' ? isSelect : isSelect.change"
              class="preview-button preview-button-change"
              type="button"
              @click="onChangeFile"
            >
              <BaseIcon icon="button-repeat" color="#52525F" />
            </button>
            <button
              v-if="typeof isSelect === 'boolean' ? isSelect : isSelect.delete "
              class="preview-button preview-button-delete"
              type="button"
              @click="onDeleteFile"
            >
              <BaseIcon icon="button-delete" color="#52525F" />
            </button>
          </div>
        </div>
      </template>
    </template>
    <template v-if="dialog && itemsListFormat && itemsListFormat.length > 0">
      <v-sheet tile flat color="transparent" :height="fullScreen ? 'calc(100vh - 120px)' : null">
        <PDFJSViewer
          v-if="selectFile.type === 'application' && selectFile.format === 'pdf'"
          :url="selectFile.url"
        />
        <v-img
          v-else-if="selectFile.type === 'image'"
          :src="selectFile.url"
          max-height="75vh"
          contain
        />
        <iframe
          v-else-if="
            selectFile.type === 'application' &&
            (selectFile.format === 'doc' ||
              selectFile.format === 'docx' ||
              selectFile.format === 'xls')
          "
          :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + selectFile.url"
          frameborder="0"
        />
        <VideoPlayer v-else-if="selectFile.type === 'video'" :src="selectFile.url" />
        <AudioPlayer
          v-else-if="selectFile.type === 'audio'"
          :src="selectFile.url"
          :fileName="selectFile.name"
        />
        <div v-else>selectFile</div>
      </v-sheet>
      <v-btn @click="dialog = false" absolute top right fab small dark class="mt-16 mr-n2">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-btn
        v-if="itemsListFormat.length > 1"
        @click="
          activeItemKey === 0 ? (activeItemKey = itemsListFormat.length - 1) : activeItemKey--
        "
        absolute
        left
        fab
        small
        dark
        class="mt-16 mr-n2 arrow"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn
        v-if="itemsListFormat.length > 1"
        @click="
          activeItemKey === itemsListFormat.length - 1 ? (activeItemKey = 0) : activeItemKey++
        "
        absolute
        right
        fab
        small
        dark
        class="mt-16 mr-n2 arrow"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <div class="d-flex justify-center dots">
        <v-btn
          v-for="(id, ii) in itemsListFormat.length"
          :key="'dot_' + ii"
          height="10"
          width="10"
          class="mx-1 my-2"
          :disabled="activeItemKey === id - 1"
          @click="activeItemKey = id - 1"
        />
      </div>
    </template>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import PDFJSViewer from 'components/PDFJSViewer'
import VideoPlayer from 'components/base/file/VideoPlayer'
import AudioPlayer from 'components/base/file/AudioPlayer'

export default {
  name: 'BaseFileView',
  components: {
    PDFJSViewer,
    VideoPlayer,
    AudioPlayer,
  },
  props: {
    item: String,
    items: {
      type: [Array],
      default: () => {
        return []
      },
    },
    itemKey: { type: Number, default: 0 },
    needApiDomain: [Boolean, String],
    iconFilled: Boolean,
    disabled: Boolean,
    minimilize: { type: Boolean, default: false },
    isSelect: { type: [Boolean, Object], default: false },
    isUpload: [String, Boolean],
    isRead: Boolean,
    uploadInfo: [Object, undefined],
    isFileList: { type: Boolean, default: false },
  },
  data: () => ({
    dialog: false,
    activeItemKey: 0,
  }),
  computed: {
    ...mapState('chat', ['chatsConfig']),
    ...mapGetters(['apiDomain']),
    fullScreen() {
      return (
        this.selectFile &&
        this.selectFile.type === 'application' &&
        (this.selectFile.format === 'pdf' ||
          this.selectFile.format === 'doc' ||
          this.selectFile.format === 'docx' ||
          this.selectFile.format === 'xls')
      )
    },
    itemsListFormat() {
      let result = []
      const apiUrl =
        this.needApiDomain &&
        (typeof this.needApiDomain === 'boolean' ? this.apiDomain + '/' : this.needApiDomain + '/')
      const getUrl = (item) =>
        typeof item === 'string'
          ? apiUrl + item
          : item.file
          ? apiUrl + (item.file.name + item.file.extension)
          : item.originalName
          ? apiUrl + (item.name + item.extension)
          : this.$getFileUrl(item)
      const getItemData = (item) => {
        const itemData = {
          url: getUrl(item),
          ...this.onThisFileType(item),
        }
        result.push(itemData)
      }
      if (this.items.length) {
        for (let item of this.items) {
          getItemData(item)
        }
      } else if (this.item) {
        getItemData(this.item)
      }

      return result
    },
    selectFile() {
      return this.items.length ? this.itemsListFormat[this.activeItemKey] : this.itemsListFormat[0]
    },
    defaultFile() {
      return this.items.length ? this.itemsListFormat[this.itemKey] : this.itemsListFormat[0]
    },
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.activeItemKey = this.itemKey || 0
      }
    },
  },
  methods: {
    onThisFileType(file) {
      // look all "type" in this.chatsConfig.files
      if (typeof file === 'string') {
        Object.keys(this.chatsConfig.files.accepted).forEach((accept) => {
          // console.log('accept', accept)
          this.chatsConfig.files.accepted[accept].some((substring) => {
            // console.log('substring', substring + '_' + file.includes(substring))
            if (file.includes(substring)) {
              return {
                type: accept,
                format: file.substring(file.lastIndexOf('.') + 1, file.length),
                name: file.substring(0, file.length - this.format.length - 1),
              }
            }
          })
        })
      } else {
        if (file.file) {
          file = file.file
        }
        const fileName = file.originalName ? file.originalName : file.name
        // console.log('file', file)
        let fileFormatData = {
          format: file.extension
            ? file.extension.replace(/[\s.,%]/g, '')
            : fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length),
          type: (file.type || file.mime).split('/')[0],
          size: this.$formatFileSizeUnits(file.size),
        }
        fileFormatData.name = fileName.substring(
          0,
          fileName.length - fileFormatData.format.length - 1,
        )
        return fileFormatData
      }
    },
    onChangeFile() {
      console.log('1 onChangeFile', this.itemKey)
      this.$emit('changeFile', this.itemKey)
    },
    onDeleteFile() {
      this.$emit('deleteFile', this.itemKey)
    },
  },
}
</script>

<style scoped lang="scss">
iframe {
  display: block; /* iframes are inline by default */
  background: #000;
  border: none; /* Reset default border */
  height: calc(100vh - 120px); /* Viewport-relative units */
  width: calc(100vw - 120px);
}

.preview {
  position: relative;
  &-picture {
    position: relative;
    z-index: 2;
    // width: 100%;
    height: auto;
    cursor: pointer;
    &::before {
      content: url('data:image/svg+xml; utf8, <svg width="22" height="15" viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 9.10894C11.9109 9.10894 12.6493 8.38962 12.6493 7.50229C12.6493 6.61496 11.9109 5.89563 11 5.89563C10.0891 5.89563 9.35066 6.61496 9.35066 7.50229C9.35066 8.38962 10.0891 9.10894 11 9.10894Z" fill="white"/><path d="M21.8527 6.96673C21.149 5.77781 17.2785 -0.188229 10.7031 0.00456941C4.62253 0.154524 1.10393 5.36008 0.147314 6.96673C0.0508068 7.12956 0 7.31427 0 7.50229C0 7.6903 0.0508068 7.87501 0.147314 8.03784C0.840038 9.20534 4.54557 15 11.022 15H11.2969C17.3775 14.85 20.9071 9.64449 21.8527 8.03784C21.9492 7.87501 22 7.6903 22 7.50229C22 7.31427 21.9492 7.12956 21.8527 6.96673ZM11 11.2511C10.2388 11.2511 9.49478 11.0313 8.8619 10.6193C8.22903 10.2074 7.73576 9.62192 7.44448 8.93691C7.15319 8.2519 7.07698 7.49813 7.22548 6.77092C7.37397 6.04371 7.7405 5.37573 8.27872 4.85144C8.81694 4.32716 9.50267 3.97011 10.2492 3.82546C10.9957 3.68081 11.7695 3.75505 12.4727 4.03879C13.176 4.32253 13.777 4.80303 14.1999 5.41953C14.6228 6.03603 14.8485 6.76083 14.8485 7.50229C14.8485 8.49654 14.443 9.45008 13.7213 10.1531C12.9996 10.8562 12.0207 11.2511 11 11.2511Z" fill="white"/></svg>');
      transition: 0.3s;
      background: #16558f30;
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
    &:hover {
      &::before {
        cursor: pointer;
        opacity: 1;
      }
    }
    :deep().v-responsive__content {
      width: 100% !important;
    }
  }
  &-file {
    border-radius: 4px;
    position: relative;
    display: grid;
    grid-template-columns: 30px auto;
    gap: 8px;
    align-items: center;
    padding: 8px;
    max-width: 390px;
    width: auto;
    background: var(--v-secondary-lighten5);
    border: 1px solid var(--v-primary-base);
    transition: 0.3s;
    &--select {
      grid-template-columns: 30px auto minmax(65px, 1fr);
      max-width: none;
      width: 100%;
    }
    &--media {
      grid-template-columns: 75px 1fr;
    }
    &-text {
      user-select: none;
      &-header {
        display: grid;
        grid-template-columns: auto max-content;
        // display: flex;
        // // flex-direction: column;
        // flex: 1;
        // // width: max-content;
        &-name {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        &-extension {
          flex: 1;
        }
      }
    }
    &:hover:deep() {
      background: var(--v-primary-base);
      .preview-file-text {
        color: var(--v-secondary-lighten5) !important;
      }
      svg {
        path {
          fill: var(--v-secondary-lighten5);
        }
      }
    }
  }
  &-buttons {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    border-radius: 4px;
    // background: #73737530;
    z-index: 2;
  }
  &-button {
    width: 32px;
    height: 32px;
    transition: 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      width: 20px;
      height: auto;
    }
    &-delete {
      &:hover {
        :deep()svg {
          path {
            fill: var(--v-error-base) !important;
          }
        }
      }
    }
    &-change {
      svg {
        width: 25px;
      }
      &:hover {
        :deep()svg {
          path {
            fill: var(--v-primary-lighten1) !important;
          }
        }
      }
    }
  }
  &--picture,
  &--video {
    background: var(--v-secondary-darken2);
    max-height: 320px;
    line-height: 0;
    .preview {
      &-buttons {
        background: #73737580;
      }
      &-button {
        :deep()svg {
          path {
            fill: white;
          }
        }
      }
    }
  }
  &__loader {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    justify-items: center;
    align-items: center;
    background: #52525f95;
    backdrop-filter: blur(2px);
    .upload_size {
      color: #ffffff;
      display: flex;
      justify-content: center;
    }
  }
  &--upload {
    img {
      height: 100px;
      width: 100px;
      object-fit: cover;
    }
    :deep().v-progress-circular__underlay {
      stroke: #9e9e9e66 !important;
    }
  }
}

.v-dialog {
  .v-btn {
    background-color: rgba(black, 0.65) !important;

    &:hover {
      background-color: rgba(black, 0.85) !important;
    }

    &.arrow {
      top: 43vh;
    }
  }

  .dots {
    position: absolute;
    bottom: 0;
    left: 0;

    .v-btn {
      min-width: auto;
      padding: 0 !important;
    }
  }
}
</style>
